import { render, staticRenderFns } from "./NoUserItemMessage.vue?vue&type=template&id=6f843dc9&scoped=true"
import script from "./NoUserItemMessage.vue?vue&type=script&lang=js"
export * from "./NoUserItemMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f843dc9",
  null
  
)

export default component.exports